<mat-card class="policy-view">
    <mat-card-header>
        <mat-card-title>Privacy Policy</mat-card-title>
        <mat-card-subtitle>This Privacy Policy explains how Av's Emprize LLC collects, uses, discloses, and protects information about users of our mobile application Yard Hostler.</mat-card-subtitle>

    </mat-card-header>


<!-- Include the rest of your privacy policy content here, using HTML tags like <p>, <h2>, etc. -->
<mat-card-content class="policy-content">
<h3>1. Information We Collect</h3>

<p>(a) <strong>Personal Information:</strong> We may collect certain personally identifiable information, such as names, email addresses, addresses, and payment information. This information is collected when voluntarily provided by you for billing and inventory management purposes.</p>

<p>(b) <strong>Usage Information:</strong> We may collect information about how you interact with the App, including device information, app usage, and inventory movement.</p>

<h3>2. How We Use Your Information</h3>

We use the information we collect for the following purposes:

To provide and maintain the App, including inventory tracking and reporting functionality.
To process billing transactions and facilitate payments with our third-party service providers.
To send email reports of inventory movements as requested by users.
<h3>3. Disclosure of Your Information</h3>

We may share your information with trusted third parties who assist us in operating the App and conducting our business, such as payment processors and email service providers. These parties are obligated to keep this information confidential.

<h3>4. Security</h3>

We implement reasonable measures to protect the information provided by you from unauthorized access or disclosure.

<h3>5. Links to Third-Party Sites</h3>

The App may contain links to third-party websites. We have no control over the content, privacy policies, or practices of these sites and are not responsible for their content or activities.

<h3>6. Children's Privacy</h3>

The app is specifically designed for adult users and is intended to assist workers in fulfilling their assigned responsibilities within their respective roles. It is not intended for use by children under the age of 16. We do not knowingly collect personally identifiable information from individuals under this age.
<h3>7. Changes to this Privacy Policy</h3>

We may update this Privacy Policy from time to time. Any changes will be posted on this page.


<h3>8. Contact Us</h3>

<p>If you have any questions or concerns about this Privacy Policy, please contact us at support&#64;avsemprize.com.</p>
</mat-card-content>
</mat-card>